module.exports = __webpack_public_path__ + "static/media/voice.f6575bce.svg";